import clsx from 'clsx'
import type { ReactNode } from 'react'

import { FvLinkButton } from '@fv/client-components'
import type { PropsWithClassName } from '@fv/client-types'

import { Help } from './Help'

type Theme = 'btn' | 'default'
type HelpHrefButtonProps = {
  href: string
  text?: ReactNode
  theme?: Theme
}

export const HelpHrefButton = ({
  href,
  text,
  className,
  theme = 'default',
}: PropsWithClassName<HelpHrefButtonProps>) => {
  return (
    <FvLinkButton
      href={href}
      target="_blank"
      className={clsx(className, {
        'flex border bg-white items-center justify-center px-2 border-fv-gray':
          theme === 'btn',
      })}
    >
      <Help>{text ?? 'Learn more'}</Help>
    </FvLinkButton>
  )
}
